<style scoped>
	.header{ display: flex;flex-direction: row;width: 100%;justify-content: space-around;background-color: rgb(92, 93, 93);}
	.header .headerItem{ padding: 0.5rem;display: inline-flex;align-items: center;}
	.header .headerItem:nth-child(1){ width: 10%;}
	.header .headerItem:nth-child(2){ width: 10%;}
	.header .headerItem:nth-child(3){ width: 80%;}
	.header .headerItem img{ width: 100%;}
	.meun{width: 100%; line-height: 50px;border-top: 1px solid #fff;}
	.swiper-container{ width: 100%; position: relative;}
	.swiper-slide{ text-align: center; font-size: 18px;background-color: rgb(92, 93, 93);color: #fff;
		/* Center slide text vertically */
		display: -webkit-box; display: -ms-flexbox; display: -webkit-flex; display: flex; -webkit-box-pack: center; -ms-flex-pack: center; -webkit-justify-content: center; justify-content: center; -webkit-box-align: center; -ms-flex-align: center; -webkit-align-items: center; align-items: center;}
	.meun{ background-color: rgb(92, 93, 93);}
	.classfyD_item.active{ color: #000;}
	.foote{ background-color: rgb(92, 93, 93);color: #fff;text-align: center;font-size: 0.8rem;padding-top: 12px;}
	.classfyMuen{ width: 100%;display: flex;flex-direction: row;justify-content: space-around;background-color: rgb(92, 93, 93);color: #fff;}
	.classfyMuen_item{font-size: 0.7rem!important;line-height: 45px;}
	.el-dropdown-link{ font-size: 0.7rem;}

</style>
<template>
	<div class="template">
		<div class="header_con" style="position: sticky;top: 0;z-index: 100;">
			<div class="header">
			<div class="headerItem">
				<img src="../../../public/icon/002.png" />
			</div>
			<div class="headerItem">
				<img src="../../../public/icon/003.png" />
			</div>
			<div class="headerItem">
				<img src="../../../public/icon/004.png" />
			</div>
		</div>
		<div class="classfyMuen">
			<div class="classfyMuen_item" @click="goHome">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link" style="color: #fff;">
						首页
					</span>

				</el-dropdown>
			</div>
			<div class="classfyMuen_item">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link" style="color: #fff;">
						平台服务
					</span>
					<el-dropdown-menu slot="dropdown" style="margin-top:-5px;margin-right:-15px;">
						<el-dropdown-item>
							<span @click="openClassfy(9,1)">设计诊断</span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(10,1)">品牌创新</span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(11,1)">市场机遇</span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(12,1)">设计众筹</span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(4,1)">设计众包 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(13,1)">小贷试产 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(14,1)">共享设备 </span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="classfyMuen_item">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link" style="color: #fff;">
						        	中心概况
						     	</span>
					<el-dropdown-menu slot="dropdown" style="margin-top:-5px;margin-right:-15px;">
						<el-dropdown-item>
							<span @click="openClassfy(5,2)">新闻资讯 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(16,2)">关于我们 </span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="classfyMuen_item">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link" style="color: #fff;">
						        	平台资源
						     	</span>
					<el-dropdown-menu slot="dropdown" style="margin-top:-5px;margin-right:-15px;">
						<el-dropdown-item>
							<span @click="openClassfy(1,3)">产业孵化 </span>
						</el-dropdown-item>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(18,3)">知识产权 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(19,3)">金融服务 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(20,3)">项目申报 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(21,3)">其他服务 </span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="classfyMuen_item">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link" style="color: #fff;">
						        	设计资源
						     	</span>
					<el-dropdown-menu slot="dropdown" style="margin-top:-5px;margin-right:-15px;">
						<el-dropdown-item>
							<span @click="openClassfy('设计成果')">设计成果 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy('专家资源')">专家资源 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy('设计机构')">设计机构 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy('设计师')">设计师 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(27)">设计院校 </span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="classfyMuen_item">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link" style="color: #fff;">
						        	赛事展会
						     	</span>
					<el-dropdown-menu slot="dropdown" style="margin-top:-5px;margin-right:-15px;">
						<el-dropdown-item>
							<span @click="openClassfy(3,5)">赛事展会 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(23,5)">业内资讯 </span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="classfyMuen_item">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link" style="color: #fff;">
						        	政策法规
						     	</span>
					<el-dropdown-menu slot="dropdown" style="margin-top:-5px;margin-right:-15px;">
						<el-dropdown-item>
							<span @click="openClassfy(6,6)">本地政策 </span>
						</el-dropdown-item>
						<el-dropdown-item>
							<span @click="openClassfy(25,6)">国内政策 </span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		</div>
		<!--<div class="meun">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide">
						<div class="classfyD_item" :class="selectIndex===0?'active':''" @click="openClassfy(0)">首页</div>
					</div>
					<div class="swiper-slide">
						<div class="classfyD_item" :class="selectIndex===1?'active':''" @click="openClassfy(1)">概念孵化</div>
					</div>
					<div class="swiper-slide">
						<div class="classfyD_item" :class="selectIndex===2?'active':''" @click="openClassfy(2)">人才服务</div>
					</div>
					<div class="swiper-slide">
						<div class="classfyD_item" :class="selectIndex===3?'active':''" @click="openClassfy(3)">赛事展会</div>
					</div>
					<div class="swiper-slide">
						<div class="classfyD_item" :class="selectIndex===4?'active':''" @click="openClassfy(4)">设计众包</div>
					</div>
					<div class="swiper-slide">
						<div class="classfyD_item" :class="selectIndex===5?'active':''" @click="openClassfy(5)">新闻资讯</div>
					</div>
					<div class="swiper-slide">
						<div class="classfyD_item" :class="selectIndex===6?'active':''" @click="openClassfy(6)">政策法规</div>
					</div>
				</div>
			</div>
		</div>-->
		<div class="content">

			<router-view name="mobRoter" v-if="reloadt"> </router-view>
		</div>

		<div class="foote">
			<div class="banuqan">copyright &copy; 2019 www.1522znsj.com</div>
			<div class="beian">蜀ICP备20018984号-1</div>
		</div>
	</div>
</template>

<script>
	import "../../assets/js/swiper.min.js"
	export default {
		data() {
			return {
				swiper_1: null,
				selectIndex: 0,
				reloadt: true
			}
		},
		created: function() {
			let _this = this;
		},
		mounted: function() {
			let _this = this;
			setTimeout(function() {
				_this.initSwiper()
			}, 500)
			_this.$router.push('/mHomepage');
		},
		methods: {
			/**  * -----初始化swiper    
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			initSwiper() {
				let _this = this;
				_this.swiper_1 = new Swiper('.swiper-container', {
					slidesPerView: 4.5,
					slidesOffsetBefore: 0
				});
			},
			openClassfy(type) {
				let _this = this;
				_this.selectIndex = type;
				_this.reload();
				if(type == '设计成果'||type == '专家资源'||type == '设计机构'||type == '设计师') {
					_this.$router.push({
						name: 'm_designCg',
						query: {
							class_id: type,
						}
					});
				} else {
					_this.$router.push({
						name: 'mnewList',
						query: {
							class_id: type,
						}
					});
				}

				/*switch(type) {
					case 3:
						_this.swiper_1.setTransition(500); //设定过渡的时间
						_this.swiper_1.setTranslate(-250)
						break;
					case 4:
						_this.swiper_1.setTransition(500); //设定过渡的时间
						_this.swiper_1.setTranslate(-250)
						break;
					default:
				}*/
			},
			reload() {
				this.reloadt = false; //先关闭，
				this.$nextTick(function() {
					this.reloadt = true; //再打开
				})
			},
			goHome() {
				let _this = this;
				_this.$router.push({
					name: 'mHomepage',
					query: {
						class_id: 0,
					}
				});
			},
		}
	}
</script>